import { useEffect, useState } from "react";
import { calculateCountdown } from "../utils/dateFormat";

function useCountdown(startDate) {
  const [time, setTime] = useState({
    days: 0,
    hours: 0,
    mins: 0,
    secs: 0,
  });

  useEffect(() => {
    if (!startDate) return;

    const update = () => {
      const { days, hours, minutes, seconds } = calculateCountdown(startDate);

      setTime({
        days,
        hours,
        mins: minutes,
        secs: seconds,
      });
    };

    update();
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [startDate]);

  return time;
}

export default useCountdown;